import _ from 'lodash';
import { JSEncrypt } from 'jsencrypt'
import {URL_API_LOGIN, URL_API_LOGOUT, URL_API_FORGOT_PASSWORD, URL_API_VALIDATE_OTP, URL_API_RESET_PASSWORD} from '../apiHitFile';
import {makeShowmodalFalse} from '../Dashboard/UserActions';
export function LoginAction(id, password){
  const publickey = process.env.REACT_APP_PUBLIC_KEY;
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publickey);
  const encyPassword = encrypt.encrypt(password);
  let obj = {'username': id , 'password': encyPassword}
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return dispatch => {
    dispatch(LoginActionPending())
    fetch(URL_API_LOGIN, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{dispatch(LoginActionSuccess(json))
        dispatch(makeShowmodalFalse())        
        })
      .catch((error) =>{dispatch({ type:'LOGIN_ACTION_ERROR', message:error.message,  showerror:true,
        isPending:false, loginAction:{},     session:""  })})
  } 
}
export function LoginActionPending(){
  return{
    type:'LOGIN_ACTION_PENDING',
    isPending:true
  }
}

export function LoginActionSuccess(data){
  if(data.status === 1001 && !_.isEmpty(data.value)){  
    return{
      type:'LOGIN_ACTION',
      showerror:false,
      loginAction:data.value,
      session:data.value.tokenType+" "+data.value.accessToken,
      isPending:false,     
    }
  } else {
    return{
      type:'LOGIN_ACTION_ERROR',
      message:data.message,
      showerror:true,
      isPending:false,
      loginAction:{},
      session:""
    }
  }
}

export function LogoutAction(userName, history) {
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append("Authorization", currentToken);
    let obj = {"employeeId": userName , 'token': currentToken}
    fetch(URL_API_LOGOUT, {
      method: 'POST',
      headers: headers,
      body:JSON.stringify(obj)
    })
    .then(res=>res.json())
    .then(json => {
      history.push("/")
      dispatch({type:"LOG_OUT"})
     })
    .catch(error => {
     history.push("/")
     dispatch({type:"LOG_OUT"})
    })
   }    
}
export function ForgotAction(userName) {
  return (dispatch, getState) => {
    dispatch(LoginActionPending())
    const currentSession = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append('cookie', currentSession)
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    let obj = {"employeeId": userName }
    fetch(URL_API_FORGOT_PASSWORD, {
      method: 'POST',
      headers: headers,
      body:JSON.stringify(obj)
    })
     .then(res=>res.json())
    .then((json) =>{
      dispatch(ForgotSucesssOTP(json))
    })
    .catch((error) =>{
      dispatch(LoginActionError(error))
    })
    }
}
export function ForgotSucesssOTP(data){
  if(data.status === 1001){
    return{
      type:'FORGOT_OTP_SUCCESS',
      message:data.message,
      showerror:true,
      showOTP:true,
      isPending:false
    }
  } else {
    return{
      type:'LOGIN_ACTION_ERROR',
      showerror:true,
      message:data.message,
      isPending:false
    }
  }
}
export function ValidateOTP(data) {
  return (dispatch, getState) => {
    let headers = new Headers()     
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json'); 
    fetch(URL_API_VALIDATE_OTP, {
      method: 'POST',
      headers: headers,
      body:JSON.stringify(data)
    })
     .then(res=>res.json())
     .then((json) =>{
       dispatch(ForgotSucesssValidateOTP(json))
      })
      .catch((error) =>{

        dispatch(LoginActionError(error))
      })
    }
}
export function ForgotSucesssValidateOTP(data){
  if(data.status === 1001){
    return{
      type:'FORGOT_OTP_SUCCESS_VALIDATE',
      message:data.message,
      showerror:true,
      showReset:true
    }
  } else {
    return{
      type:'LOGIN_ACTION_ERROR',
      showerror:true,
      message:'Not Valid OTP',
      isPending:false
    }
  }
}
export function ResetPassword(data) {
  return (dispatch, getState) => { 
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_RESET_PASSWORD, {
      method: 'POST',
      headers: headers,
      body:JSON.stringify(data)
    })
     .then(res=>res.json())
     .then((json) =>{dispatch(ResetPasswordSuceess(json))
      })
     .catch((error) =>{ dispatch({ type:'LOGIN_ACTION_ERROR',showerror:true, message:error.message,isPending:false,resetDone:true })
     })
    }
}
export function ResetPasswordSuceess(data){
  if(data.status === 1001){
  return {
    type:'RESET_PASSWORD_SUCCESS',
    showerror:true,
    message:data.message,
    resetDone:true,
    }
  } else {
    return{
      type:'LOGIN_ACTION_ERROR',
      showerror:true,
      message:data.message,
      isPending:false,
      resetDone:true
    }
  }
}

export function LoginActionError(data){
    return{
      type:'LOGIN_ACTION_ERROR',
      showerror:true,
      message:data.message,
      isPending:false
    }
}
export function ResetAll(){
  return{
    type:"RESET_ALL",
    showOTP:false,
    showReset:false
  }
}
export function closeModalPopUp(){
  return{
    type:'LOGIN_ACTION_MODAL_CLOSE',
    showerror:false
  }
}

